"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHITE = exports.TRANSPARENT_WHITE_75 = exports.TRANSPARENT_GREY_20 = exports.TRANSPARENT_GREY_65 = exports.GREY_10 = exports.GREY_20 = exports.GREY_30 = exports.GREY_40 = exports.GREY_50 = exports.GREY_60 = exports.GREY_70 = exports.GREY_80 = exports.GREY_90 = exports.PINK_20 = exports.PINK_30 = exports.PINK_40 = exports.PINK_50 = exports.PINK_60 = exports.RED_10 = exports.RED_20 = exports.RED_30 = exports.RED_40 = exports.RED_50 = exports.RED_60 = exports.YELLOW_20 = exports.YELLOW_30 = exports.YELLOW_40 = exports.YELLOW_50 = exports.YELLOW_60 = exports.GREEN_10 = exports.GREEN_20 = exports.GREEN_30 = exports.GREEN_40 = exports.GREEN_45 = exports.GREEN_50 = exports.GREEN_60 = exports.PALE_BLUE_40 = exports.PALE_BLUE_50 = exports.PALE_BLUE_70 = exports.WARM_BLUE_30 = exports.WARM_BLUE_40 = exports.WARM_BLUE_50 = exports.WARM_BLUE_60 = exports.BLUE_30 = exports.BLUE_35 = exports.BLUE_40 = exports.BLUE_50 = exports.BLUE_60 = void 0;
exports.BLUE_60 = '#121297';
exports.BLUE_50 = '#2727E6';
exports.BLUE_40 = '#9393F3';
exports.BLUE_35 = '#B5B5FF';
exports.BLUE_30 = '#DEDEFB';
exports.WARM_BLUE_60 = '#82C7E6';
exports.WARM_BLUE_50 = '#91D8EC';
exports.WARM_BLUE_40 = '#ADE4F7';
exports.WARM_BLUE_30 = '#CDF1FE';
exports.PALE_BLUE_70 = '#BDD7FF';
exports.PALE_BLUE_50 = '#E1EDFF';
exports.PALE_BLUE_40 = '#F0F6FF';
exports.GREEN_60 = '#00833E';
exports.GREEN_50 = '#16AB59';
exports.GREEN_45 = '#5CC48B';
exports.GREEN_40 = '#A2DDBD';
exports.GREEN_30 = '#D0EEDE';
exports.GREEN_20 = '#CCE6D8';
exports.GREEN_10 = '#E5F3EC';
exports.YELLOW_60 = '#FFCD00';
exports.YELLOW_50 = '#FFDA00';
exports.YELLOW_40 = '#FFE54D';
exports.YELLOW_30 = '#FFF099';
exports.YELLOW_20 = '#FFFADB';
exports.RED_60 = '#E10000';
exports.RED_50 = '#FF4141';
exports.RED_40 = '#FF7A7A';
exports.RED_30 = '#FFA6A6';
exports.RED_20 = '#FEC2C2';
exports.RED_10 = '#FEE7E7';
exports.PINK_60 = '#FF929F';
exports.PINK_50 = '#FFBAC4';
exports.PINK_40 = '#FFCFD6';
exports.PINK_30 = '#FFE3E7';
exports.PINK_20 = '#FFEAED';
exports.GREY_90 = '#111118';
exports.GREY_80 = '#58585D';
exports.GREY_70 = '#757579';
exports.GREY_60 = '#A0A0A0';
exports.GREY_50 = '#B7B7B9';
exports.GREY_40 = '#C9C9C9';
exports.GREY_30 = '#D9D9D9';
exports.GREY_20 = '#EBEBEB';
exports.GREY_10 = '#F6F6F6';
exports.TRANSPARENT_GREY_65 = 'rgba(17, 17, 23, 0.65)';
exports.TRANSPARENT_GREY_20 = 'rgba(17, 17, 23, 0.20)';
exports.TRANSPARENT_WHITE_75 = 'rgba(255,255,255, 0.75)';
exports.WHITE = '#FFFFFF';
